import { render, staticRenderFns } from "./ClockGeolocationDetails.vue?vue&type=template&id=33bd41fb"
import script from "./ClockGeolocationDetails.vue?vue&type=script&lang=js"
export * from "./ClockGeolocationDetails.vue?vue&type=script&lang=js"
import style0 from "./ClockGeolocationDetails.vue?vue&type=style&index=0&id=33bd41fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports